// «Mening hisobim» va «Mening amallarim» kesh kalitlari.
//
// ⚠️ PREFIKS `cashdesk` DAN ALOHIDA va bu ataylab. Kassa har pul
// amalidan keyin butun `['cashdesk']` shoxini bekor qiladi
// (`useCashOperation`, `useCombinedSale`) — bu to'g'ri, chunki u yerdagi
// har bir son amal bilan o'zgaradi. Bu yerdagi ma'lumot esa boshqa
// tabiatli: hisob-kitob rejimi va qarz limiti kunlab o'zgarmaydi,
// komissiya yig'indisi esa DAVR bo'yicha hisoblanadi. Ularni ham har
// to'ldirishda qayta so'rash kassirning telefonida sof yo'qotish
// bo'lardi.

import { moneyOnlyApplies, type OperationFilter } from './profileApi'

export const profileKeys = {
  all: ['partnerAccount'] as const,
  /** Sherik tuguni — rejim, holat, nom. Sessiya davomida deyarli o'zgarmaydi */
  node: (agentId: string) => ['partnerAccount', 'node', agentId] as const,
  balance: (agentId: string) => ['partnerAccount', 'balance', agentId] as const,
  /** ⚠️ Faqat `POSTPAID` da so'raladi — `DEPOSIT` da server rad etadi */
  outstanding: (agentId: string) => ['partnerAccount', 'outstanding', agentId] as const,
  /**
   * Kunlik va oylik PUL chegarasi + sarflangani.
   *
   * ⚠️ DAVR KALITDA YO'Q va bu ataylab: server oynani O'ZI tanlaydi
   * (`agent.fund_counter` dagi kun/oy belgisi). Kalitga sana qo'shish
   * har yarim tunda yangi bo'sh kesh yaratardi, holbuki javob baribir
   * bitta — «hozir qancha qoldi».
   */
  fundLimits: (agentId: string) => ['partnerAccount', 'fundLimits', agentId] as const,
  /**
   * Komissiya QOIDASI — «men necha foizda ishlayapman».
   *
   * ⚠️ DAVR KALITDA YO'Q va bo'lmasligi ham kerak: qoida davrga
   * bog'liq emas, u HOZIR kuchda turgan bitta shart. Yig'indi kaliti
   * (`commission`) bilan aralashtirilmaydi — ular boshqa-boshqa
   * endpoint va boshqa-boshqa savol.
   */
  commissionRule: (agentId: string) => ['partnerAccount', 'commissionRule', agentId] as const,
  /**
   * ⚠️ DAVR KALITDA. Usiz sana filtri o'zgarganda ekranda oldingi
   * kunning summasi qolib ketardi — va u ishonarli ko'rinardi.
   * `null` — davrsiz so'rov, ya'ni serverning joriy oyi.
   */
  commission: (agentId: string, window: { from: string; to: string } | null) =>
    ['partnerAccount', 'commission', agentId, window?.from ?? 'month', window?.to ?? 'month'] as const,
  /**
   * ⚠️ DAVR, HAR BIR FILTR, TORAYISH va SAHIFA kalitda.
   *
   * Bittasi tushib qolsa TanStack Query o'sha kalit uchun saqlangan
   * ESKI javobni qaytaradi va yangisini so'ramaydi ham — ekran filtrga
   * umuman javob bermayotgandek ko'rinardi, tarmoqda esa hech narsa
   * yo'q. Turlar ro'yxati TARTIBLANADI: `[FUND, GRANT]` va
   * `[GRANT, FUND]` — bitta so'rov, ikkita kesh bo'lmasin.
   *
   * ⚠️ TORAYISH `moneyOnlyApplies` DAN o'qiladi, xom bayroqdan emas:
   * aniq tur tanlanganda bayroq so'rovga umuman qo'shilmaydi, ya'ni
   * `moneyOnly` ning ikki qiymati AYNI so'rovni beradi. Xom bayroqni
   * kalitga qo'yish o'sha bitta javobni ikki keshga bo'lardi.
   */
  operations: (
    agentId: string,
    window: { from: string; to: string },
    filter: OperationFilter,
    page: number,
    moneyOnly: boolean,
  ) =>
    [
      'partnerAccount',
      'operations',
      agentId,
      window.from,
      window.to,
      [...filter.kinds].sort().join(','),
      filter.status ?? 'any',
      filter.q.trim(),
      moneyOnlyApplies(filter, moneyOnly) ? 'money' : 'all',
      page,
    ] as const,
} as const
